import { render, staticRenderFns } from "./SettingDialog.vue?vue&type=template&id=d8abddfe"
import script from "./SettingDialog.vue?vue&type=script&lang=js"
export * from "./SettingDialog.vue?vue&type=script&lang=js"
import style0 from "./SettingDialog.vue?vue&type=style&index=0&id=d8abddfe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports